import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useOnboarding } from '../../../context/AdminSellerRegistrationOB';
import useBank from '../../../hooks/useBank';

import { Copy } from '@phosphor-icons/react';
import { Tooltip, ClickAwayListener, Button } from '@mui/material';

const AdminSellerRegisCompleted = () => {
    const navigate = useNavigate();
    const { qris } = useOnboarding();

    const token = localStorage.getItem('serviceToken');

    const { fetchActiveBank, data: activeBank } = useBank();

    const [usedBank, setUsedBank] = useState(null);

    useEffect(() => {
        fetchActiveBank();
    }, []);

    useEffect(() => {
        if (qris?.bankTransferId && activeBank.length > 0) {
            const selectedBank = activeBank.find((bank) => bank.id === qris.bankTransferId);
            setUsedBank(selectedBank);
        }
    }, [qris, activeBank]);

    const [open, setOpen] = useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
        navigator.clipboard.writeText(usedBank.accountNumber);
    };

    return (
        <div className="completedscreen flex-center">
            <div className="caption position-relative text-center px-32" style={{ paddingTop: '120px', marginTop: '260px' }}>
                <img
                    src="/assets/images/icon/personsucceed.png"
                    className="position-absolute"
                    style={{ top: '-260px', left: '50%', transform: 'translateX(-50%)' }}
                />
                <div className="text-black text_quicksand">
                    <div className="text-32 fw-bold mb-20">Shop Registration Success!</div>

                    {usedBank && usedBank.accountNumber !== '-' && (
                        <div>
                            <br />
                            <div className="text-16 mb-8">
                                <b>Bank Transfer Details</b>
                            </div>
                            <div className="text-14 mb-4">
                                Account Name: <b>{usedBank.accountName}</b>
                            </div>
                            <div className="text-14 mb-4 d-flex justify-content-center align-items-center gap-8">
                                Account Number: <b>{usedBank.accountNumber}</b>
                                <ClickAwayListener onClickAway={handleTooltipClose}>
                                    <div>
                                        <Tooltip
                                            onClose={handleTooltipClose}
                                            open={open}
                                            disableFocusListener
                                            disableHoverListener
                                            disableTouchListener
                                            title="Copied!"
                                            slotProps={{
                                                popper: {
                                                    disablePortal: true
                                                }
                                            }}
                                        >
                                            <button onClick={handleTooltipOpen}>
                                
                                    <Copy size={16} />
                                </button>
                                        </Tooltip>
                                    </div>
                                </ClickAwayListener>
                            </div>
                            <div className="text-14 mb-4">
                                Bank Name: <b>{usedBank.bankName}</b>
                            </div>
                            <div className="text-14 mb-4">
                                SWIFT Code: <b>{usedBank.swiftCode}</b>
                            </div>
                            <div className="text-14 mb-4">
                                Bank Address <br /> {usedBank.address}
                            </div>
                            <br />
                        </div>
                    )}
                    {usedBank && usedBank.accountNumber === '-' && <img src={qris?.qrisImage} alt="QRIS" />}
                    {/* <div className="mb-64">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                </div> */}
                    <button
                        className="btn btn_mart_primary mb-60 text-14"
                        style={{ width: '100%', height: '46px' }}
                        onClick={() => window.open(`https://seller.sg.iwant-asia.com/login?auth=${token}`)}
                        // onClick={() => window.open(`https://seller.id.iwant-asia.com/login?auth=${token}`)}
                    >
                        Go to my shop
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminSellerRegisCompleted;
